import {StripeAvatar, TypingRow} from '@stripe-internal/conversations-ui';
import {view} from '@sail/ui/deprecated';

export const TypingIndicator = () => {
  const avatar = <StripeAvatar />;

  return (
    <view.div
      style={{flexGrow: 0}}
      data-testid="uh-sign-in-prompt-typing-indicator"
      // Since this is just a typing indicator, we're setting the `aria-live` attribute to `off` so that
      // screen readers don't interrupt theirselves when new messages come in.
      aria-live="off"
    >
      <TypingRow avatar={avatar} />
    </view.div>
  );
};
